import clsx from "clsx";
import React from "react";
import { Pie } from "react-chartjs-2";
import PropTypes from "prop-types";
import styles from "./PieChart.scss";

const propTypes = {
  /**
   * Data containing complete inputs for drawing pie chart.
   */
  pieData: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
  /**
   * Heading label for PieChart
   */
  heading: PropTypes.string.isRequired,
};

const defaultProps = {};

const options = {
  plugins: {
    datalabels: {
      display: false,
    },
  },
  title: { display: false },
  legend: { display: false },
  events: [],
};

const formatPieData = (pieData) => {
  const res = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        borderWidth: 0,
      },
    ],
  };
  pieData.forEach((pie) => {
    res.labels.push(pie.label);
    res.datasets[0].backgroundColor.push(pie.color);
    res.datasets[0].data.push(pie.value);
  });
  return res;
};

function PieChart(props) {
  const { pieData, heading } = props;

  return (
    <div className={clsx(styles.base)}>
      <h6>{heading}</h6>
      <div className={clsx(styles.main_section)}>
        <div>
          {pieData?.map((item) => (
            <div key={item.label} className={clsx(styles.section_info)}>
              <div
                className={clsx(styles.dot)}
                style={{ backgroundColor: item?.color }}
              />
              <div className={clsx(styles.sub_div)}>
                <span className={clsx(styles.label_text)}>{item.label}</span>
                <span className={clsx(styles.value_text)}>{item?.value}</span>
              </div>
            </div>
          ))}
        </div>
        <div className={clsx(styles.section_chart)}>
          <Pie options={options} data={formatPieData(pieData)} />
        </div>
      </div>
    </div>
  );
}

PieChart.propTypes = propTypes;
PieChart.defaultProps = defaultProps;

export default PieChart;
